import React, {Component} from 'react';
import {
    Platform,
    View,
    TouchableOpacity,

    Image,
} from 'react-native';
import HMTextView from "./HMTextView";
import Colors, {colorDark, colorPrimary} from "../tools/Colors"
import {moderateScale} from "../tools/Scaling";

import {connect} from "react-redux";

import PathFile from "../assets/PathFile";

import {DataProvider, LayoutProvider} from "recyclerlistview";


class HMCheckBox extends Component {
    constructor(props) {
        super(props);
        let {data} = props;

        // let idx = arraySelect ? arraySelect.findIndex(obj => obj.id === item.id) : -1;

        //   let check1 = arraySelect ? (idx !== -1) : (data.indexSelect == (item.id || (item.id == 0) ? item.id : item.value));
        this.state = {
            numColumns: Platform.OS === "web" ? 3 : 2,
            isSelected: false,
            canChangeSize: false,

            dataProvider: new DataProvider((r1, r2) => {
                return r1 !== r2;
            }),
            layoutProvider: new LayoutProvider(
                () => {
                    return 'VSEL'; //Since we have just one view type
                },
                (type, dim, index) => {
                    switch (type) {
                        case 'VSEL':
                            dim.width = moderateScale(100);
                            dim.height = moderateScale(38);
                            //dim.width = 0;
                            // if (index % 3 === 0) {
                            //     dim.width = 3 * columnWidth;
                            //     dim.height = 300;
                            // } else if (index % 2 === 0) {
                            //     dim.width = 2 * columnWidth;
                            //     dim.height = 250;
                            // } else {
                            //     dim.width = columnWidth;
                            //     dim.height = 250;
                            // }
                            break;
                        default:
                            dim.width = 0;
                            dim.height = 0;
                    }
                }
            ),
        }
    }

    render() {
        const {title,borderRadius,style,value, onPress, styleRoot, styleRootChild, viewCustom, type, styleBox = null, styleBoxTick = null} = this.props;

        return (
            <TouchableOpacity
                onPress={onPress}

                style={[{
                    flexDirection: "row",
                    alignItems:"center",
                    // alignSelf: "flex-end",
                    marginHorizontal: moderateScale(6),
                    marginVertical: moderateScale(8)
                },style]}>

                <View
                >
                    <HMTextView
                        //text="اطلاعاتم بصورت محرمانه باشد"
                        text={title}
                        style={{color: !value ? Colors.colorDark : Colors.green}}
                    />

                </View>
                <View style={{width: moderateScale(8)}}/>
                <View style={{
                    width: moderateScale(24),
                    height: moderateScale(24),
                    backgroundColor: '#ffffff',
                    borderRadius: borderRadius?borderRadius:moderateScale(12),
                    alignItems: 'center', justifyContent: 'center',
                    borderWidth: moderateScale(1),
                    borderColor: Colors.gray

                }}>
                    <Image
                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                        source={(PathFile.image.Check)}
                        //resizeMode="stretch"
                        style={[!value ? {
                            width: moderateScale(0),
                            height: moderateScale(0),
                        } : {


                            width: moderateScale(18),
                            height: moderateScale(18),
                        }]}/>
                </View>

            </TouchableOpacity>

        );
    }


}


const mapStateToProps = (state) => {

    return {}
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(HMCheckBox);
